// ============================================================
// MANIC MEETER — Deutsche Inhalte: Kollegen
// ============================================================
// Nur die Sprüche. Die Vornamen stehen in ../names.ts — sie sind in beiden
// Sprachen dieselben.

import { ColleagueRole } from "../../types";


export const CATCH_PHRASES: Record<Exclude<ColleagueRole, ColleagueRole.Sprachbarriere>, string[]> = {
  [ColleagueRole.FrontendDev]: [
    "Also, die Pixel sind 2 off...",
    "Können wir das nicht in React machen?",
    "Das sieht im Darkmode aber anders aus!",
    "Der Button hat 1px zu viel Padding.",
    "Responsiveness ist kein Feature, sondern Pflicht!",
    "Ich muss kurz den Cache leeren...",
    "Chrome DevTools sagen was anderes.",
    "Können wir bitte Web Components verwenden?",
    "Das CSS Grid ist nicht aligned.",
    "Wir brauchen unbedingt eine Design-System-Library.",
    "Der Z-Index ist komplett kaputt.",
    "Mobile First, Leute. Mobile First.",
    "Der Lighthouse-Score ist unter 80 gefallen.",
    "Ich hab da nen Accessibility-Issue gefunden...",
    "Können wir das Dropdown bitte custom machen?",
    "TypeScript wirft hier einen Fehler, aber es funktioniert trotzdem.",
    "Das Layout bricht bei 320px Breite.",
    "Wir sollten die Bundle-Size tracken.",
    "Können wir Tailwind einführen? Oder doch lieber nicht?",
    "Der Safari rendert das komplett anders.",
    "npm install hat 847 Vulnerabilities gefunden. Wie immer.",
    "Warum hat jemand !important benutzt? 43 Mal?",
    "Der Darkmode hat jetzt einen Darkmode.",
    "Ich hab 3 Stunden einen CSS-Bug gesucht. War ein Semikolon.",
    "Mein Localhost sieht perfekt aus. Produktion? Naja.",
    "Können wir bitte aufhören, jQuery zu benutzen? Es ist 2026.",
    "Die Konsole zeigt 200 Deprecation Warnings. Ist normal.",
    "Wir haben 3 verschiedene State-Management-Lösungen. Alle gleichzeitig.",
    "Der Figma-Export hat andere Fonts als das, was wir lizenziert haben.",
    "Ich hab den Button jetzt schon 5 Mal umgebaut. Welche Version nochmal?",
    "Die Animation laggt auf dem iPhone 8. Hat das noch jemand?",
    "Können wir endlich SSR machen? Oder CSR? Oder ISR? Oder... was auch immer?",
    "Warum hat der Designer 47 verschiedene Grautöne benutzt?",
    "Mein Hot-Reload funktioniert nicht mehr. Seit dem letzten npm update.",
    "Der IE11-Support wurde offiziell gestrichen. Ich feiere das.",
    "Die Font-Datei ist 4MB groß. Brauchen wir wirklich kyrillisch?",
    "Der Kunde sagt, die Seite lädt langsam. Er benutzt Edge. Auf Windows 7.",
    "Wir haben jetzt ein Monorepo. Also eigentlich drei Monorepos.",
    "Die Storybook-Instanz braucht 12 Minuten zum Starten.",
    "Ich hab das mit CSS gelöst. Ja, auch die Business-Logik.",
    "Die Web-Vitals sind rot. Aber nur auf dem Staging-Server. Wahrscheinlich.",
    "Unser Design-Token-System hat mehr Tokens als Pantone Farben hat.",
    "Der Pull Request hat 847 Dateien geändert. Es war ein Linter-Fix.",
    "Warum rendert Firefox das Flexbox-Gap anders? Warum?!",
    "Wir haben 14 verschiedene Button-Varianten. Der Designer will eine 15.",
    "Mein Docker-Container für die Frontend-Toolchain braucht 8GB RAM.",
    "Die KI hat mir 200 Zeilen CSS generiert. Zwei davon brauche ich.",
    "Copilot schlägt mir seit heute früh dieselbe kaputte Funktion vor.",
    "Ich hab mir den Fehler von der KI erklären lassen. Sie hat sich entschuldigt und ihn wiederholt.",
    "Das Design kommt jetzt aus der KI. Es sieht aus wie alles andere auch.",
    "Die KI hat mir ein Framework empfohlen, das es nicht gibt.",
    "Ich hab den generierten Code refactored. Übrig blieb ein Semikolon.",
  ],
  [ColleagueRole.BackendDev]: [
    "Das ist ein Feature, kein Bug.",
    "Auf meinem Rechner läuft's...",
    "Microservices lösen das Problem.",
    "Die API ist RESTful, das reicht.",
    "Wir brauchen einen Cache davor.",
    "Haben wir Tests dafür? Nein? Cool.",
    "Die Datenbank macht den Bottleneck, nicht mein Code.",
    "Docker löst das.",
    "Ich baue kurz ein Quick-Fix in Production.",
    "Die Legacy-Codebasis will ich nicht anfassen.",
    "Das Logging reicht völlig aus.",
    "Wir sollten auf Kubernetes migrieren.",
    "Die Latenz liegt im akzeptablen Bereich.",
    "Das refactoren wir in Sprint 47.",
    "Der Endpoint ist dokumentiert. Irgendwo im Wiki.",
    "Wir brauchen mehr RAM auf dem Server.",
    "CORS ist kein Backend-Problem.",
    "Die Migration ist theoretisch abwärtskompatibel.",
    "Git blame sagt, das war der Praktikant.",
    "Die Queue ist voll, aber das sortiert sich von allein.",
    "Ich hab den Fix direkt auf main gepusht. Was soll schon passieren.",
    "Die Datenbank hat 4 Millionen verwaiste Einträge. Stört aber nicht.",
    "Wir haben 97% Code Coverage. Die anderen 3% sind die wichtigen.",
    "Der Cronjob läuft seit 2019. Keiner weiß, was er tut.",
    "Ich hab den Server neugestartet. Problem gelöst.",
    "Das ist ein Known Issue. Seit 3 Jahren.",
    "Die env-Variablen stehen im README. Theoretisch.",
    "Wir haben eine Race Condition. Aber nur unter Last. Also immer.",
    "Der Health-Check sagt grün. Der Service ist trotzdem tot.",
    "Ich hab den Fehler gefunden. Es war ein Encoding-Problem. Natürlich.",
    "Die API gibt 200 zurück. Aber im Body steht 'error'. Designentscheidung.",
    "Wir brauchen ein Service Mesh. Nein, ich kann nicht erklären warum.",
    "Der Datenbankindex fehlt. Seit 2 Jahren. Performance war 'akzeptabel'.",
    "Ich hab das Secret in den Code committed. Kurz. Für 3 Sekunden.",
    "Die Migration hat 4 Stunden gedauert. Am Freitag. Um 17 Uhr.",
    "Wir haben 73 Microservices. 4 davon tun was. Die anderen 'könnten wir brauchen'.",
    "Der Webhook hat 3 Millionen Mal gefeuert. Pro Stunde. Das war kein Feature.",
    "Wir speichern Passwörter jetzt richtig. Seit letzter Woche.",
    "Der Loadbalancer balanciert nicht. Er schickt alles an Server 3.",
    "Wir haben den gleichen Bug dreimal gefixt. Er kommt immer wieder.",
    "Die Logs sind auf 500GB angewachsen. In einer Woche.",
    "Ich hab ein Bash-Skript geschrieben. Es ist jetzt geschäftskritisch.",
    "Das Terraform-State-File ist korrupt. Wieder.",
    "Wir deployen mit Copy-Paste auf den Server. Agil.",
    "Der Retry-Mechanismus hat den Server ge-DDoS-t. Unseren eigenen.",
    "Ich hab die Doku geschrieben. In meinem Kopf. Ich bin die Doku.",
    "Die KI wollte meine Migration mit DROP TABLE beginnen.",
    "Ich schreibe die Tests jetzt mit KI. Sie testen, dass true wahr ist.",
    "Ich hab drei Stunden einen Bug gesucht, den die KI in vier Sekunden eingebaut hat.",
    "Das Modell kennt unsere API besser als unsere Doku. Das sagt mehr über die Doku.",
    "Der Agent hat 200 Zeilen Migration geschrieben. Ich hab 200 Zeilen gelöscht.",
    "Die KI kennt jedes Design Pattern. Angewendet hat sie alle gleichzeitig.",
  ],
  [ColleagueRole.ClientManager]: [
    "Der Kunde will das aber bis gestern!",
    "Können wir da agil rangehen?",
    "Der Stakeholder braucht Visibility!",
    "Wir müssen da proaktiv kommunizieren.",
    "Das Expectation Management stimmt nicht.",
    "Der Client hat das anders verstanden.",
    "Wir brauchen einen Executive Summary.",
    "Die Deadline ist nicht verhandelbar.",
    "Können wir da ein Quick Win liefern?",
    "Das Alignment mit dem Client fehlt.",
    "Die Customer Experience muss stimmen.",
    "Wir müssen die Beziehung zum Kunden pflegen.",
    "Das geht so nicht in den Review.",
    "Der Kunde zahlt, der Kunde entscheidet.",
    "Wir brauchen ein Status-Update für den Client.",
    "Können wir das in einer Eskalationsrunde klären?",
    "Die Beauftragung ist noch nicht through.",
    "Der GU hat da andere Vorstellungen.",
    "Wir sollten ein Jour Fixe mit dem Kunden aufsetzen.",
    "Das Angebot muss bis Freitag raus.",
    "Der Kunde hat eine 'kleine Änderung'. In Anführungszeichen.",
    "Wir müssen dem Kunden das Scope-Creep erklären. Diplomatisch.",
    "Die Nachkalkulation wird... interessant.",
    "Der Kunde hat den Vertrag nicht gelesen. Aber Erwartungen hat er.",
    "Ich sag dem Kunden, das geht. Ihr macht das möglich, ja?",
    "Das Angebot ist raus. Inklusive 3 Sachen, die wir nicht können.",
    "Der Kunde ruft an. Ja, auch am Freitag um 17:30.",
    "Das Change Request Formular hat 14 Seiten. Der Kunde will es bis morgen.",
    "Der Kunde sagt 'minimal'. Er meint 'komplett neu'. Wie immer.",
    "Wir haben dem Kunden 2 Optionen gegeben. Er will Option 3.",
    "Die Abnahme ist in einer Stunde. Der Kunde hat die Anforderungen geändert. Vor 5 Minuten.",
    "Der Kunde hat den Prototyp für das fertige Produkt gehalten. Ups.",
    "Wir brauchen einen NDA. Für den NDA. Ja, wirklich.",
    "Der Kunde hat 'agil' gehört und denkt, es heißt 'schneller und billiger'.",
    "Das Feedback kam als 47 einzelne E-Mails. Innerhalb von 10 Minuten.",
    "Der Ansprechpartner beim Kunden hat gewechselt. Zum dritten Mal. In einem Monat.",
    "Ich hab dem Kunden gesagt: 'Das ist komplex.' Er hat gehört: 'Das geht bis Freitag.'",
    "Der Kunde will das Design in Comic Sans. Ich wünschte, ich würde scherzen.",
    "Die Projektlaufzeit war 6 Monate. Wir sind im Monat 14.",
    "Der Kunde hat eine Idee. Es ist immer schlimm, wenn der Kunde eine Idee hat.",
    "Wir haben ein Fixed-Price-Projekt angenommen. Der Scope hat sich verdreifacht.",
    "Der Kunde will einen Report. Über die Reports. Reportception.",
    "Ich telefoniere seit 3 Stunden mit dem Kunden. Er beschreibt immer noch das Problem.",
    "Der Vertrag sagt 'best effort'. Der Kunde versteht 'Garantie'.",
    "Wir haben den Meilenstein erreicht! Der Kunde hat den Meilenstein verschoben.",
    "Der Kunde möchte 'nur eine kleine Sache'. Es ist nie eine kleine Sache.",
    "Der Kunde will 'irgendwas mit KI'. Konkreter wurde es nicht.",
    "Ich hab dem Kunden die KI-Zusammenfassung geschickt. Er hat sie mit KI zusammenfassen lassen.",
    "'Machen Sie das mit KI?' — Ja. — 'Kostet das dann weniger?' — Nein.",
    "Der Kunde fragt, ob die KI auch das Angebot schreiben kann. Sie hat es bereits.",
    "Der Kunde hat unsere KI-Antwort an seine KI weitergeleitet. Wir warten auf die Antwort.",
    "'Ist da eigentlich ein Mensch dran?' — Situationsabhängig.",
  ],
  [ColleagueRole.HRManager]: [
    "Wir sind wie eine Familie hier!",
    "Das steht so im Kulturhandbuch.",
    "Employer Branding ist key!",
    "Die Mitarbeiter-Zufriedenheit hat Prio 1.",
    "Wir haben da einen Workshop geplant.",
    "Das Onboarding muss optimiert werden.",
    "Die Diversity-Quote stimmt noch nicht.",
    "Wir brauchen ein Retention-Programm.",
    "Feedback-Kultur fängt bei jedem Einzelnen an.",
    "Das spreche ich im nächsten Townhall an.",
    "Wir launchen eine neue Benefits-Plattform.",
    "Die Employee Experience muss besser werden.",
    "Das nehmen wir im People & Culture-Meeting auf.",
    "Wer hat noch nicht die Compliance-Schulung gemacht?",
    "Wir brauchen mehr Team-Building-Events.",
    "Die Work-Life-Balance darf nicht leiden.",
    "Das regelt der neue Purpose-Workshop.",
    "Fachkräftemangel ist auch unser Problem.",
    "Können wir da ein Mentoring-Programm aufsetzen?",
    "Die interne Kommunikation muss transparenter werden.",
    "Wir haben eine anonyme Umfrage gemacht. 3 Leute haben teilgenommen.",
    "Der Obstkorb zählt als Benefit, oder?",
    "Wir haben jetzt einen Feel-Good-Manager. Fühlt ihr euch schon besser?",
    "Die Kündigung kam überraschend. Also für uns.",
    "New Work heißt nicht, dass ihr nicht kommen müsst.",
    "Das Mitarbeiter-Gespräch ist freiwillig. Aber bitte komm trotzdem.",
    "Wir haben ein neues Tool für Zeiterfassung. Das fünfte dieses Jahr.",
    "Das Diversity-Ziel ist 50/50. Wir sind bei 94/6. Aber wir haben einen Plan.",
    "Die Stellenausschreibung steht seit 8 Monaten online. Wir sind wählerisch.",
    "Der Feel-Good-Manager hat gekündigt. Wegen schlechter Stimmung.",
    "Wir haben ein neues Organigramm. Es widerspricht dem von letztem Monat.",
    "Die Krankmeldungen häufen sich. Vor allem montags und freitags. Zufall?",
    "Unser Homeoffice-Vertrag erlaubt 2 Tage. Manche interpretieren das kreativ.",
    "Wir suchen einen Teamleiter. Intern traut sich niemand.",
    "Der Workshop 'Stressbewältigung' wurde wegen Stress abgesagt.",
    "Das Feedback-Gespräch war sehr konstruktiv. Also: ich hab geredet, er hat genickt.",
    "Die Gehaltsrunde ist transparent. Transparent heißt: alle wissen, dass es nichts gibt.",
    "Wir haben eine neue Datenschutzrichtlinie. 87 Seiten. Freiwillige Lektüre.",
    "Das Assessment Center hatte 6 Bewerber. 5 haben abgesagt. Der 6. auch.",
    "Der Betriebsrat hat Einwände. Der Betriebsrat hat immer Einwände.",
    "Wir bieten jetzt Mental Health Days an. Maximal einen. Pro Jahr.",
    "Die Employer Branding Kampagne zeigt Leute, die hier nicht arbeiten.",
    "Wir haben ein Buddy-System eingeführt. 3 Buddies haben schon gekündigt.",
    "Der Purpose-Workshop hat ergeben: unser Purpose ist unklar.",
    "Die Mitarbeiterbefragung hat 12% Teilnahme. Wir nennen es 'repräsentativ'.",
    "Das Offboarding war so gut, dass der Mitarbeiter fast geblieben wäre. Fast.",
    "Wir haben jetzt eine KI-Richtlinie. Sie wurde von einer KI geschrieben.",
    "Die Bewerbungen sind KI-generiert, unsere Absagen auch. Alle sparen Zeit.",
    "Ich habe 400 Anschreiben gelesen. Alle beginnen mit 'mit großem Interesse'.",
    "Wir schulen jetzt KI-Kompetenz. Die Schulung ist ein Video von 2023.",
    "Wir suchen jemanden mit fünf Jahren Erfahrung in einem zwei Jahre alten Modell.",
    "Die KI hat den Bewerber aussortiert. Die Begründung reichen wir nach, sobald wir sie verstehen.",
  ],
  [ColleagueRole.MarketingGuru]: [
    "Wir müssen den Content leveragen!",
    "ROI des Synergy-Funnels optimieren!",
    "Touchpoints entlang der Customer Journey!",
    "Die Reach auf LinkedIn ist gestiegen!",
    "Wir brauchen mehr Thought Leadership.",
    "Der Funnel konvertiert nicht gut genug.",
    "Können wir einen Podcast starten?",
    "Das muss viral gehen!",
    "Wir brauchen eine Influencer-Kooperation.",
    "Die Brand Awareness ist noch zu niedrig.",
    "Content is King, Distribution is Queen!",
    "Wir müssen die organic Reach pushen.",
    "Der Newsletter hat 0.3% Click-Rate. Ist OK.",
    "Können wir da ein Whitepaper machen?",
    "Die Kampagne braucht mehr Storytelling.",
    "Wir müssen die Target Audience sharpenen.",
    "Growth Hacking ist der Weg nach vorne.",
    "Die Social-Media-Strategie steht. Theoretisch.",
    "Paid vs. Organic — die ewige Frage.",
    "Wir brauchen User Generated Content.",
    "Unser TikTok hat 12 Follower. Davon 4 aus dem Team.",
    "Die Landingpage braucht noch einen Hero-Shot. Und ein Video. Und Testimonials.",
    "Wir disruptieren den Markt! Mit einem Blogartikel.",
    "Der Marketing-Qualified-Lead war die Mutter vom Praktikanten.",
    "Können wir ChatGPT unsere Posts schreiben lassen? Ach, tun wir schon?",
    "Das Rebranding hat 6 Monate gedauert. Der neue Blauton ist 2% anders.",
    "Unsere E-Mail-Kampagne hat einen Abmelderate-Rekord aufgestellt!",
    "Wir haben einen Hashtag kreiert. Es trendet nicht. Aber wir benutzen ihn intern.",
    "Die Pressemitteilung wurde 3 Mal umgeschrieben. Keiner hat sie gelesen.",
    "Wir sponsoren jetzt einen Podcast. 47 Hörer. 46 davon aus dem Marketing-Team.",
    "Der SEO-Berater sagt, wir ranken auf Seite 8. Für unseren eigenen Firmennamen.",
    "Wir haben eine Guerilla-Marketing-Aktion gemacht. Die Polizei war nicht begeistert.",
    "Das Webinar hatte 200 Anmeldungen. 3 sind aufgetaucht. Einer war ich.",
    "Unser Messestand ist doppelt so groß wie letztes Jahr. Das Budget auch.",
    "Der A/B-Test läuft seit 6 Monaten. Ergebnis: A und B sind gleich schlecht.",
    "Wir haben eine Customer Persona erstellt. Sie heißt Marketing-Manuela.",
    "Die Konkurrenz hat unser Design kopiert. Ich bin geschmeichelt und wütend.",
    "Wir machen jetzt Employer Branding. Schritt 1: Stockfotos von lächelnden Menschen.",
    "Der QR-Code auf dem Plakat führt zur falschen Seite. Seit 3 Monaten.",
    "Unser Brand Voice Guidelines Dokument ist 60 Seiten lang. Niemand hat es gelesen.",
    "Wir haben einen Meme-Account erstellt. Die Rechtsabteilung hat ihn sofort geschlossen.",
    "Die Print-Anzeige hat einen Tippfehler. 10.000 Exemplare sind schon gedruckt.",
    "Der Influencer hat uns getaggt. Er hat 200 Follower. 150 sind Bots.",
    "Wir brauchen 'mehr Engagement'. Keiner weiß genau, was das bedeutet.",
    "Das Marketingbudget wurde gekürzt. Aber die Ziele verdoppelt. Natürlich.",
    "Wir haben jetzt einen Brand Ambassador. Es ist der Praktikant.",
    "Wir sind ab sofort AI-powered. Technisch ändert sich nichts.",
    "Das Model in der Kampagne hat drei Arme, aber die Reichweite stimmt.",
    "Ich hab 60 Slogans generieren lassen. Wir nehmen den, den ich vorher schon hatte.",
    "'KI-gestützt' steigert die Klickrate um 12%. Egal wovon.",
    "Wir generieren jetzt 40 Posts pro Woche. Gelesen wird keiner.",
    "Die Zielgruppenanalyse ist von der KI. Die Zielgruppe inzwischen auch.",
  ],
  [ColleagueRole.Chef]: [
    "Mein Terminkalender ist voll, also kurz...",
    "Das ist strategisch wichtig für Q3!",
    "Wir müssen Ownership zeigen!",
    "Die Vision muss klar kommuniziert werden.",
    "Ich erwarte da mehr Initiative.",
    "Das Budget für nächstes Jahr steht noch nicht.",
    "Wir müssen effizienter werden. Punkt.",
    "Das eskalieren wir wenn nötig bis zum Board.",
    "Ich hab das dem CEO so versprochen.",
    "Performance ist kein Nice-to-Have.",
    "Wir brauchen mehr Execution, weniger Planung.",
    "Die Zahlen sprechen für sich.",
    "Das ist ein Top-Down-Entscheid.",
    "Ich möchte da Resultate sehen. Bald.",
    "Unser Wettbewerb schläft nicht.",
    "Die Shareholder erwarten Wachstum.",
    "Lead by example, Leute.",
    "Wir drehen jeden Stein um.",
    "Das nächste Town Hall wird kritisch.",
    "Ich will keine Ausreden, ich will Lösungen.",
    "Ich habe Open Door Policy! Termin bitte über meine Assistenz.",
    "Wir müssen unsere Komfortzone verlassen. Ich fange morgen an.",
    "Denkt wie Unternehmer! Aber fragt vorher mich.",
    "Die Transformation beginnt bei jedem Einzelnen. Außer bei mir.",
    "Ich war gestern auf einer Konferenz. Wir brauchen KI. Überall.",
    "Das Mittagessen mit dem Investor war produktiv. Wir hatten Hummer.",
    "Ich delegiere das. Also ihr macht das.",
    "Mein Golfpartner sagt, KI ist die Zukunft. Er verkauft Versicherungen.",
    "Ich habe gerade ein sehr inspirierendes Buch gelesen. Den Titel hab ich vergessen.",
    "Die Strategie steht. Sie ändert sich nur noch wöchentlich.",
    "Ich hab in meiner Karriere schon ganz andere Krisen gemeistert. Angeblich.",
    "Town Hall Pflicht für alle. Ich komme 20 Minuten zu spät. Wie immer.",
    "Ihr seid mein bestes Team. Das sage ich allen meinen Teams.",
    "Wir müssen disruptiv denken! Aber bitte im Rahmen der Compliance.",
    "Ich bin in einer Stunde beim nächsten Termin. In Dubai. Per Video natürlich.",
    "Kosten senken und gleichzeitig Qualität steigern. Ist doch logisch.",
    "Meine Vision? Die steht im Intranet. Seite 47. Fussnote 3.",
    "Wir sind ein Start-up im Geiste. Mit 3000 Mitarbeitern.",
    "Der Quartalbericht kommt heute raus. Die Zahlen sind... kreativ dargestellt.",
    "Ich brauche das Ergebnis in einer Powerpoint. Maximal 3 Folien. Mit allen Details.",
    "Unser Wettbewerbsvorteil? Dass wir noch existieren.",
    "Ich mache keine Fehler. Ich mache 'Learnings'.",
    "Die Reorganisation wird diesmal funktionieren. Die siebte ist der Charm.",
    "Team-Dinner heute Abend. Ist freiwillig. Aber ich merke mir, wer nicht kommt.",
    "Ich bin nahbar. Schreibt mir einfach eine E-Mail. Meine Assistenz leitet weiter.",
    "Der Bonus fällt dieses Jahr kleiner aus. Meiner nicht, eurer.",
    "Wir müssen jetzt AI-first denken. Fragt mich nicht, was danach kommt.",
    "Ich hab unsere Strategie von der KI prüfen lassen. Sie fand sie 'ambitioniert'.",
    "Die KI spart uns 30% Zeit. Die füllen wir mit Meetings über die KI.",
    "Niemand wird durch KI ersetzt. Das lasse ich mir gleich schriftlich von der KI bestätigen.",
    "Ich hab die KI gefragt, ob wir zu viele Meetings haben. Sie sagt ja. Besprechen wir.",
    "Die Effizienzgewinne sind erheblich. Nachweisen konnten wir sie noch nicht.",
  ],
  [ColleagueRole.Abteilungsleiter]: [
    "In meiner Abteilung läuft das anders.",
    "Das eskaliere ich nach oben.",
    "Wir brauchen mehr Headcount!",
    "Die Priorisierung muss von oben kommen.",
    "Mein Team ist am Limit.",
    "Wir haben das im Abteilungsmeeting besprochen.",
    "Da fehlt mir die Freigabe von der GF.",
    "Cross-functional zusammenarbeiten? Gerne, aber...",
    "Das Budget reicht nie.",
    "Die andere Abteilung blockiert uns.",
    "Wir brauchen klare Verantwortlichkeiten.",
    "Das war schon immer so in meinem Bereich.",
    "Die Ressourcenplanung stimmt vorne und hinten nicht.",
    "Können wir externe Unterstützung holen?",
    "Das Reporting muss bis Freitag fertig sein.",
    "Wir müssen die Prozesse standardisieren.",
    "Meine Leute machen schon Überstunden.",
    "Das gehört nicht in meine Zuständigkeit.",
    "Ich spreche das im Management-Meeting an.",
    "Die Zahlen aus meiner Abteilung sind solide.",
    "Warum hat die andere Abteilung mehr Budget? Weil sie lauter schreien.",
    "Mein Team hat 3 Leute verloren. Ersatz kommt 'bald'.",
    "Die Excel-Tabelle für die Ressourcenplanung hat 47 Tabs.",
    "Wir haben ein Siloproblem. Aber mein Silo ist gut organisiert.",
    "Ich hab dem Chef gesagt, das geht nicht. Er sagt, es muss.",
    "Die Reorg betrifft uns nicht. Wahrscheinlich. Hoffentlich.",
    "Meine Abteilung hat die beste Kaffeemaschine. Das ist kein Zufall.",
    "Die andere Abteilung hat 3 Teamleiter. Wir haben einen halben.",
    "Ich hab einen 12-Seiten-Report geschrieben. Niemand hat ihn gelesen. Wie immer.",
    "Das Org-Chart zeigt mich über Marketing. Marketing sieht das anders.",
    "Wir haben ein Strategiepapier geschrieben. Es widerspricht dem vom letzten Quartal.",
    "Mein Vorgänger hat Prozesse eingeführt. Ich hab sie alle abgeschafft. Und neue eingeführt.",
    "Die KPIs sind grün. Weil ich die Grenzwerte angepasst habe.",
    "Wir brauchen einen weiteren Teamleiter. Der jetzige ist... überarbeitet.",
    "Das Management-Offsite war produktiv. Wir waren in einem Spa.",
    "Ich hab das im Führungskreis angesprochen. Es wurde vertagt. Zum dritten Mal.",
    "Mein Stellvertreter macht das, wenn ich im Urlaub bin. Er weiß es nur noch nicht.",
    "Die Umstrukturierung betrifft nur die anderen. Hoffe ich.",
    "Wir haben jetzt OKRs. Zusätzlich zu den KPIs. Und dem Balanced Scorecard. Und der Roadmap.",
    "Ich sitze in 14 Lenkungsausschüssen. Ich lenke in keinem davon irgendwas.",
    "Die Zielvereinbarung ist unterschrieben. Die Ziele sind 'ambitioniert'.",
    "Meine Abteilung hat die wenigsten Beschwerden. Weil keiner weiß, wo man sich beschwert.",
    "Wir machen jetzt agil. Also die anderen. Ich mache weiterhin Wasserfall.",
    "Das Budget ist aufgeteilt. Fair. Also fair aus meiner Perspektive.",
    "Ich hab den Konflikt zwischen Team A und Team B gelöst. Beide hassen jetzt mich.",
    "Die Präsentation für den Vorstand ist fertig. 80 Folien. Für 10 Minuten Slot.",
    "Ich hätte gern einen KI-Reifegrad-Report. Bis Freitag. Von der KI.",
    "Wir brauchen eine KI-Roadmap. Und eine Roadmap für die KI-Roadmap.",
    "Die Zahlen im Report sind KI-generiert, die Erklärung dazu auch. Passt also zusammen.",
    "Ich habe eine Taskforce gegründet. Sie evaluiert, ob wir eine Taskforce brauchen.",
    "Wir sind in der Pilotphase. Seit vierzehn Monaten.",
    "Die KI-Initiative hat einen eigenen Lenkungskreis. Der tagt wöchentlich.",
  ],
  [ColleagueRole.Teamleiter]: [
    "Nächstes Standup besprechen wir das.",
    "Ich hab das im Jira erfasst.",
    "Timebox bitte einhalten!",
    "Wer nimmt das Ticket?",
    "Die Velocity stimmt nicht.",
    "Wir haben zu viel Work in Progress.",
    "Daily ist um 9, nicht um 9:15.",
    "Können wir das vom Board ablesen?",
    "Das blockt unser Sprint Goal.",
    "Ich mache nachher ein Refinement.",
    "Wir brauchen klarere Acceptance Criteria.",
    "Der Burndown sieht nicht gut aus.",
    "Bitte keine Side-Quests im Sprint.",
    "Wer hat den Pull Request reviewed?",
    "Die Retro-Action-Items sind noch offen.",
    "Das ist out of scope für den Sprint.",
    "Wir müssen die Definition of Done einhalten.",
    "Pair Programming wäre hier sinnvoll.",
    "Code Review bis heute Abend, bitte.",
    "Ich erstelle gleich ein Blocker-Ticket.",
    "Der Stand-up ist für Status, nicht für Diskussionen! *diskutiert 20 Minuten*",
    "Wir haben 3 Story Points geschafft. Von 40.",
    "Ich hab ein neues Jira-Label erstellt: 'nicht mein Problem'.",
    "Das Confluence ist aktuell. Stand: 2023.",
    "Wir brauchen ein Meeting, um die Meetings zu reduzieren.",
    "Der Sprint heißt 'Sprint 94 - diesmal schaffen wir es'.",
    "Ich hab den Blocker eskaliert. Zweimal. Keiner hat geantwortet.",
    "Die Code-Review-Queue hat 47 offene PRs. Manche sind von letztem Jahr.",
    "Ich hab ein neues Retro-Format erfunden: 'Wer ist schuld?'.",
    "Der Sprint ist kaputt. Nicht der Code. Der Sprint selbst.",
    "Wir haben jetzt Pair Programming Pflicht. Keiner findet einen Partner.",
    "Mein Kanban-Board hat so viele Spalten, es braucht einen Scrollbar.",
    "Die User Story passt auf ein Post-It. Der Kommentar braucht 3 Seiten.",
    "Ich tracke die Team-Velocity in einer Excel-Tabelle. Ironie? Welche Ironie?",
    "Das Team-Event habe ich organisiert. Bowlen. Alle hassen Bowlen. Ich weiß.",
    "Der Sprint Review hat 5 Minuten gedauert. Wir hatten nichts zu zeigen.",
    "Ich hab die Retro-Ergebnisse in ein Ticket geschrieben. Es ist jetzt im Backlog. Seite 47.",
    "Wir haben 12 Epics offen. 11 davon sind 'in Progress'. Seit Q1.",
    "Die Sprintplanung hat 4 Stunden gedauert. Für einen 2-Wochen-Sprint.",
    "Mein Lieblingssatz: 'Das besprechen wir im nächsten Daily.' Spoiler: Nie.",
    "Der Tech-Debt-Backlog ist größer als der Feature-Backlog. Deutlich.",
    "Ich hab einen Jira-Workflow mit 23 Status-Übergängen gebaut. Effizient.",
    "Das Release ist morgen. Die Tests laufen noch. Manche sogar erfolgreich.",
    "Wir machen Scrum by the Book. Das Buch ist von 2005.",
    "Die Team-Umfrage sagt: 8/10 Zufriedenheit. 2 von 10 haben teilgenommen.",
    "Ich hab ein Meeting abgesagt! Und 3 neue erstellt. Netto minus, wie immer.",
    "Nutzt gern KI, aber prüft alles. Also: schreibt es lieber selbst.",
    "Der KI-Notetaker hat mir Aufgaben zugewiesen, die ich nie zugesagt habe.",
    "Wir messen ab sofort KI-Nutzung pro Kopf. Ja, ich weiß.",
    "Ich hab dein Ticket von der KI schätzen lassen. Zwei Tage. Sie sagt immer zwei Tage.",
    "Bitte kennzeichnet KI-generierte Texte. Ja, diese Mail auch.",
    "Die Schätzung kam vom Modell. Die Verantwortung bleibt bei dir.",
  ],
  [ColleagueRole.Designer]: [
    "Das Spacing stimmt nicht.",
    "Figma ist die Source of Truth!",
    "Können wir einen Design Sprint machen?",
    "Die Farbpalette ist nicht WCAG-konform.",
    "Wir brauchen User Research.",
    "Das Wireframe ist noch nicht freigegeben.",
    "Pixel-perfekt, bitte.",
    "Der Prototyp ist fast fertig. Fast.",
    "Können wir eine Heuristic Evaluation machen?",
    "Die User Journey muss flüssiger sein.",
    "Icons dürfen nicht inkonsistent sein.",
    "Wir brauchen mehr Whitespace.",
    "Das Design System braucht ein Update.",
    "Die Farbe ist #FF5733, nicht #FF5734!",
    "UX ist keine Dekoration.",
    "Können wir A/B-testen, welcher Button besser ist?",
    "Die Micro-Interactions fehlen noch.",
    "Ich brauch Feedback vom User Testing.",
    "Das Hover-State-Design ist noch offen.",
    "Wir sollten die Information Architecture überdenken.",
    "Der Kunde will Comic Sans. Ich kündige.",
    "Das sind nicht unsere Brand Colors. Das ist Rot.",
    "Ich hab 3 Varianten gemacht. Der Chef will eine vierte.",
    "Das Icon sieht bei 16px aus wie ein Unfall.",
    "Wir haben jetzt 14 verschiedene Blautöne im Produkt.",
    "Der Developer hat mein Design umgesetzt. Ich erkenne es nicht wieder.",
    "Können wir den Text kürzen? Er zerstört mein Layout.",
    "Das Mockup ist fertig. Also, das Mockup vom Mockup. Das richtige Mockup kommt nächste Woche.",
    "Ich brauche eine Woche für das Design. 'Warum so lang?' Weil Iterationen.",
    "Der Kunde will es 'modern'. Was heißt 'modern'? Runde Ecken. Immer runde Ecken.",
    "Mein Figma-Projekt hat 340 Frames. Ich blicke selbst nicht mehr durch.",
    "Die Accessibility-Prüfung hat 200 Fehler ergeben. Wir fangen mit den Farben an.",
    "Der Entwickler hat mein Padding in Margin verwandelt. Ich spüre den Schmerz.",
    "Wir haben jetzt eine Design-Sprache. Niemand spricht sie.",
    "Das User Testing hat ergeben: Keiner findet den Login-Button. Er ist in der Mitte.",
    "Ich hab 3 Stunden an einem Icon gearbeitet. Es ist 16x16 Pixel groß.",
    "Die Schrift kostet 3000€ pro Jahr. Der Kunde will Arial. Immer Arial.",
    "Der Prototyp funktioniert perfekt. In Figma. Die Realität ist... anders.",
    "Wir haben A/B-getestet. Ergebnis: Beide Varianten sind schlecht.",
    "Mein Portfolio hat 200 Projekte. In 180 davon wurde mein Design ignoriert.",
    "Der Darkmode sieht besser aus als der Lightmode. Natürlich wollen alle Lightmode.",
    "Ich habe die Personas aktualisiert. Marketing-Manuela heißt jetzt AI-Annika.",
    "Das Moodboard ist genehmigt. Der Vorstand dachte, es wäre ein Kunstprojekt.",
    "Wir haben ein Designsystem mit 500 Komponenten. 3 werden benutzt.",
    "Der Kunde sagt 'weniger ist mehr'. Dann fügt er 7 Call-to-Action-Buttons hinzu.",
    "Meine Lieblingsfrage: 'Kannst du das noch ein bisschen schöner machen?'",
    "Die KI hat 80 Varianten generiert. Alle sehen aus wie ein Startup von 2021.",
    "Bitte keine KI-Bilder im Pitch. Man sieht die Hände.",
    "Der Kunde hat unser Logo kurz nachgenerieren lassen. Es ist jetzt fast unser Logo.",
    "Ich hab das Moodboard generiert. Jetzt will der Kunde genau das — inklusive Artefakte.",
    "Der Prompt war 'clean und modern'. Bekommen habe ich lila Farbverläufe.",
    "Die KI kann alles außer Weißraum.",
  ],
  [ColleagueRole.Praktikant]: [
    "Äh, soll ich Protokoll schreiben?",
    "Das hab ich im Studium anders gelernt...",
    "Kann mir jemand Zugang zum Wiki geben?",
    "Wo ist nochmal der Drucker?",
    "Sorry, ich war noch im anderen Meeting.",
    "Darf ich auch was sagen?",
    "Ich hab das gegoogelt, aber...",
    "Ist das jetzt ein Meeting oder ein Workshop?",
    "Mein Zugang zum VPN funktioniert immer noch nicht.",
    "Muss ich das auch in Jira eintragen?",
    "Wann gibt es hier Mittagessen?",
    "Äh, was bedeutet 'EOB'?",
    "Soll ich das in Confluence dokumentieren?",
    "Ich hab mein Passwort vergessen...",
    "Mein Vertrag geht nur noch bis nächsten Monat.",
    "Kann mir jemand Git erklären?",
    "Ist Freitag hier wirklich casual?",
    "Mir hat niemand gesagt, dass es eine Kleiderordnung gibt.",
    "Ich kenne den Jira-Workflow noch nicht so gut.",
    "Entschuldigung, ich hab nochmal eine dumme Frage...",
    "Ich hab aus Versehen auf main gepusht. Ist das schlimm?",
    "Mein Bachelorarbeit-Thema ist jetzt dieses Projekt. Hilfe.",
    "Darf ich um 16 Uhr gehen? Ich hab Uni.",
    "Ich hab den Production-Server für den Testserver gehalten...",
    "Bekommt man hier auch einen zweiten Monitor?",
    "Ich hab ChatGPT gefragt und es sagt, ihr macht das falsch.",
    "Kann ich meine Mutter als Referenz angeben?",
    "Ich hab den Git-Branch 'yolo-deploy' genannt. War das falsch?",
    "Mein Bildschirm zeigt nur noch blaue Schrift auf blauem Grund. Hilfe.",
    "Darf ich beim Daily auch über meine Katze reden?",
    "Ich hab eine Pull Request erstellt. Mit 14.000 Zeilen. Ist das viel?",
    "Kann man Jira auch auf dem Handy benutzen? Frage für einen Freund.",
    "Ich hab das Unit-Testing gegoogelt. Klingt aufwändig. Muss das sein?",
    "Soll ich die Fehler fixen oder nur dokumentieren?",
    "Ich hab den API-Key auf Twitter gepostet. Ist das schlimm?",
    "Entschuldigung, aber was ist ein Sprint? Rennen wir?",
    "Mein Laptop hat 4 Aufkleber. Bin ich jetzt ein richtiger Entwickler?",
    "Ich hab im Code 'TODO: fix later' geschrieben. Das zählt als Dokumentation, oder?",
    "Die Kaffeemaschine im 3. Stock macht den besseren Cappuccino. Nur so als Info.",
    "Ich weiß nicht, was ein Merge Conflict ist, aber ich hab offenbar einen erzeugt.",
    "Mein Mentor hat mir gesagt, ich soll 'mehr lesen'. Er meint Dokumentation, oder?",
    "Können wir das Meeting auf nach 10 Uhr legen? Ich bin kein Morgenmensch.",
    "Ich hab eine Präsentation vorbereitet. In Comic Sans. Ironisch. Glaube ich.",
    "Mein Praktikumsbericht hat jetzt 3 Seiten. Über die Kaffeemaschine.",
    "Ich hab den Server neugestartet. Den falschen. Tut mir leid.",
    "Wer ist eigentlich dieser 'Kubernetes' und warum reden alle über ihn?",
    "Ich hab die Doku mit KI geschrieben. War als Zwei-Wochen-Aufgabe geplant.",
    "Darf ich fragen, warum wir die KI-Antwort in einem Meeting vorlesen?",
    "Ich hab die KI gefragt, was ein Alignment-Call ist. Sie wusste es auch nicht genau.",
    "Kann die KI auch meinen Praktikumsbericht schreiben? ...Ich frage für mich.",
    "Ich soll die KI-Ausgabe prüfen. Ich bin seit zwei Wochen hier.",
    "Wenn die KI die Aufgaben macht — was lerne ich dann?",
  ],
  [ColleagueRole.ScrumMaster]: [
    "Wie fühlt sich das Team dabei?",
    "Parkplatz-Thema, bitte!",
    "Timeboxen wir das auf 2 Minuten!",
    "Das ist ein Impediment, das räume ich weg.",
    "Wie hoch ist eure Confidence?",
    "Daily ist zum Synchronisieren, nicht zum Diskutieren.",
    "Wer facilitatet das nächste Meeting?",
    "Wir brauchen psychologische Sicherheit.",
    "Lasst uns eine Fishbowl-Diskussion machen.",
    "Die Sprint Velocity normalisiert sich noch.",
    "Können wir das über ein Kanban-Board tracken?",
    "Ich mache gleich eine Retrospektive.",
    "Working Agreement bitte beachten!",
    "Wir leben Agilität, wir reden nicht nur drüber.",
    "Bitte Dot-Voting für die Themen.",
    "Das lösen wir im Inspect & Adapt.",
    "Scrum sagt, maximal 10 Leute im Sprint Planning.",
    "Die Burndown-Chart zeigt einen Trend.",
    "Team-Autonomie ist wichtig!",
    "Können wir ROTI machen? Return on Time Invested?",
    "Ich hab einen neuen Eisbrecher! Jeder sagt sein Lieblingsgemüse.",
    "Das Team braucht Safe Space. Ich bestelle Sitzkissen.",
    "Mein Retro-Format heißt 'Segelboot'. Oder 'Starfish'. Oder 'Mad-Sad-Glad'. Ich kann mich nicht entscheiden.",
    "Das Impediment-Backlog hat jetzt mehr Items als das Product-Backlog.",
    "Ich hab einen 3-tägigen Scrum-Master-Kurs gemacht. Ich weiß jetzt alles.",
    "Wer hat das Daily auf 45 Minuten verlängert? Ah, ich war das.",
    "Vertrauen im Team aufbauen. Schritt 1: Vertrauensfall. Keiner fängt auf.",
    "Ich hab eine Übung aus meinem Coaching-Seminar mitgebracht. Es dauert nur 90 Minuten.",
    "Das Team braucht mehr Empowerment. Was genau das bedeutet, kläre ich noch.",
    "Mein neues Ritual: Jeder sagt morgens eine Affirmation. Pflicht.",
    "Wir tracken jetzt die Happiness-Metrik. Das Team ist 'mittel-glücklich'.",
    "Ich hab ein neues Buch gelesen: 'Scrum für die Seele'. Empfehle ich allen.",
    "Der Team-Canvas hängt an der Wand. Seit 6 Monaten hat niemand draufgeschaut.",
    "Wir machen jetzt Lean Coffee. Kein Kaffee, aber lean.",
    "Die Retrospektive hat ergeben: Wir brauchen weniger Retrospektiven.",
    "Ich facilitiere jetzt auch Kaffeepausen. Struktur ist wichtig.",
    "Das Team hat eine Reifegradstufe erreicht. Welche, sage ich nicht. Es ist Phase 1.",
    "Wir haben eine 'Working Agreement' erstellt. 47 Punkte. Alle ignoriert.",
    "Der Velocity-Trend zeigt: Es wird besser! Oder die Schätzungen werden schlechter.",
    "Ich hab den Slack-Channel #scrum-feelings erstellt. 0 Nachrichten bisher.",
    "Mein Zertifikat hängt jetzt gerahmt über meinem Schreibtisch. In Gold.",
    "Wir experimentieren mit Mob Programming. 8 Leute, 1 Tastatur. Chaos.",
    "Das Team soll selbstorganisiert arbeiten. Aber bitte genau so, wie ich es will.",
    "Ich hab eine Meditation vor dem Stand-up eingeführt. Die ersten 3 sind eingeschlafen.",
    "Das Impediment-Board hat ein eigenes Impediment: Es ist voll.",
    "Mein Retro-Highlight: 'Können wir den Scrum Master austauschen?' Anonym. Natürlich.",
    "Die KI hat die Story Points geschätzt. Für alles: 13.",
    "Ich hab die Retro von der KI auswerten lassen. Ergebnis: 'Kommunikation verbessern'. Wie immer.",
    "Wir sind jetzt AI-augmented agile. Das Board sieht trotzdem gleich aus.",
    "Der Bot hat das Daily zusammengefasst. In elf Absätzen.",
    "Die KI schlägt vor, die Retro abzuschaffen. Besprechen wir in der Retro.",
    "Wir haben jetzt ein Impediment-Board. Die KI hat es befüllt. Es ist voll.",
  ],
  [ColleagueRole.ProductOwner]: [
    "Das ist Prio 1, wie die anderen 47 Tickets.",
    "Der Business Value ist immens!",
    "Sprint Goal ist Sprint Goal!",
    "Das Backlog ist priorisiert. Theoretisch.",
    "Wir brauchen mehr Customer Feedback.",
    "Die Story ist Ready, oder?",
    "Können wir das noch in den Sprint quetschen?",
    "Die Stakeholder wollen ein Feature mehr.",
    "Das MVP muss nächste Woche stehen.",
    "Die User Story ist zu groß, die splitten wir.",
    "Time-to-Market ist entscheidend.",
    "Die Acceptance Criteria sind klar. Eigentlich.",
    "Der ROI rechtfertigt das Investment.",
    "Können wir ein Beta-Release machen?",
    "Die Feature-Requests stapeln sich.",
    "Wir pivoten die Strategie. Mal wieder.",
    "Epics, Storys, Tasks — alles in einem Sprint?",
    "Die Roadmap hat sich geändert. Überraschung.",
    "Customer-Centric denken, bitte.",
    "Die Konkurrenz hat das Feature schon.",
    "Das Backlog hat 500 Einträge. Die ältesten sind von 2021.",
    "Ich hab die Prioritäten geändert. Nicht fragen warum.",
    "Die Story hat keine Akzeptanzkriterien. Die kommen noch. Irgendwann.",
    "Wir brauchen das Feature gestern. Liefern wir übermorgen.",
    "Der Stakeholder hat angerufen. Er will alles anders.",
    "Wir hatten ein Refinement? Oh, ich war im anderen Call.",
    "Mein Backlog ist priorisiert: alles ist Prio 1. Problem gelöst.",
    "Der Stakeholder hat seine Meinung geändert. Während des Meetings. Zweimal.",
    "Die Roadmap geht bis Q4. Wir sind in Q1 und schon 3 Monate hinten.",
    "Ich hab die User Story dreimal umformuliert. Sie sagt immer noch nichts aus.",
    "Das Feature wird seit 8 Sprints mitgezogen. Es ist unser 'Dauerticket'.",
    "Wir pivoten. Wieder. Der dritte Pivot dieses Jahr.",
    "Die Story hat 100 Story Points. Wir schätzen nicht in Story Points? Na gut, 100 Tage.",
    "Der Stakeholder will ein Dashboard. Über alle anderen Dashboards.",
    "Ich hab die Sprint Demo gemacht. Das Einzige was funktioniert hat, war die Begrüßung.",
    "Die Feature-Flag-Liste hat 200 Einträge. 180 stehen auf 'nobody knows'.",
    "Customer Journey Map? Hab ich. Auf einer Serviette. Reicht das?",
    "Wir brauchen Discovery. Und dann Delivery. Und dann nochmal Discovery. Ad infinitum.",
    "Das Product-Market-Fit haben wir. Sagen wir. Dem Investor.",
    "Mein OKR für dieses Quartal: 'Dinge tun.' Messbar? Naja.",
    "Der Feature-Request kam um 23:47. Per WhatsApp. Vom CEO. An mich privat.",
    "Wir canceln das Feature. Nach 6 Monaten Entwicklung. 'Strategische Neuausrichtung'.",
    "Die User-Interviews haben ergeben: Keiner will, was wir bauen. Aber sonst super Feedback.",
    "Das Produkt hat 3 aktive Nutzer. 2 davon aus unserem QA-Team.",
    "Ich hab den Product-Discovery-Workshop moderiert. 4 Stunden. Ergebnis: 'Mehr Daten nötig.'",
    "Der Investor fragt nach dem ARR. Ich hab 'Area Rug Revenue' gesagt. Er hat gelacht. Glaube ich.",
    "Die KI hat 40 User Stories generiert. Keine davon will jemand haben.",
    "Das Backlog wurde KI-priorisiert. Ganz oben steht jetzt ein Ticket von 2022.",
    "Ich hab 'MVP' eingegeben und ein ganzes Produkt zurückbekommen.",
    "Der Kunde schreibt seine Anforderungen mit KI, wir lesen sie mit KI. Irgendwo dazwischen war mal ein Bedürfnis.",
    "Die Persona ist KI-generiert. Sie hat noch nie etwas gekauft.",
    "'Was will der Nutzer?' — Das Modell sagt: alles.",
  ],
};
